import { useCallback, useRef } from 'react';
import { MaxSizeFileType } from 'shared/constants/MAX_SIZE';
import { isValidFileSize } from 'shared/utils/isValidFileSize';

export const useValidateDropzoneFiles = () => {
  const modalRef = useRef<boolean>();
  const validateDropzoneFiles = useCallback((acceptedFiles: File[]) => {
    const validFiles = acceptedFiles.filter((file) => {
      const fileType = file.type.split('/')[0];
      const { isValid } = isValidFileSize(fileType as MaxSizeFileType, file);
      if (!isValid) {
        modalRef.current = true;
      }
      return isValid;
    });

    return validFiles;
  }, []);

  return { modalRef, validateDropzoneFiles };
};
